module.exports = "/fonts/herculift.woff?c565df48a702f9dd7df7b0f8d965f0d9";